<template>
  <v-dialog v-model="dialog" persistent max-width="350">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      <v-btn icon v-on="on">
        <v-icon>fas fa-pen</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        Edit Group
        <v-spacer></v-spacer>
        <v-btn :loading="loadingBtn" @click="close" icon>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- <div>{{ SortedLinks }}</div> -->
        <!-- <div>{{ values }}</div> -->
        <p v-html="message" class="red--text"></p>
        <p v-html="ErrMessage" class="red--text"></p>
        <v-form ref="GrouForm">
          <v-text-field
            name="Groupname"
            readonly
            v-model="GroupName"
            :rules="[v => !!v || 'Group Name is required']"
            label="Group Name"
            id="Groupid"
          ></v-text-field>
          <v-treeview
            ref="tree"
            v-model="values"
            open-on-click
            selectable
            :items="AccessRout"
            item-text="text"
            item-children="child"
            item-key="text"
          ></v-treeview>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loadingBtn" block @click="AddGoup" color="success"
          >Save Edited</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
// import _ from "lodash";
export default {
  props: {
    AtFinshed: { type: Function },
    Name: { type: String, required: true },
    Routes: { type: Array, required: true },
  },
  data: () => ({
    dialog: false,
    values: [],
    GroupName: "",
    message: "",
    loadingBtn: false,
    ErrMessage: "",
  }),
  watch: {
    values() {
      this.message = "";
    },
    GroupName() {
      this.ErrMessage = "";
    },
  },
  computed: {
    ...mapGetters(["GroupGetters", "GetterRouter"]),
    AccessRout() {
      return this.GroupGetters.reduce((Access, route) => {
        let AccRout = {};
        if (route.hasChild) {
          AccRout = {
            ...route,
            child: route.child.filter(chld => {
              return this.GetterRouter.includes(chld.text);
            }),
          };
          if (AccRout.child.length) Access.push(AccRout);
        } else {
          if (this.GetterRouter.includes(route.text)) Access.push(route);
        }
        return Access;
      }, []);
    },
  },
  methods: {
    close() {
      this.dialog = false;
      //   this.values = [];
      //   this.$refs.GrouForm.reset();
    },
    AddGoup() {
      this.ErrMessage = "";
      if (this.$refs.GrouForm.validate()) {
        this.message = "";
        if (this.values.length === 0) {
          this.message = `please select Access path of  <span class="black--text">${this.GroupName}</span> `;
          return;
        }
        this.loadingBtn = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/users/EditGroup",
            data: { GroupName: this.GroupName, route: this.values },
          })
          .then(() => {
            // console.log(result);
            // this.values = [];
            // this.$refs.GrouForm.reset();
            this.AtFinshed();
            this.close();
            this.loadingBtn = false;
          })
          .catch(error => {
            // console.log(error.response);
            if (error.response) this.ErrMessage = error.response.data;
            this.loadingBtn = false;
          });
        this.message = "";
      }
    },
  },
  mounted() {
    this.values = this.Routes;
    this.GroupName = this.Name;
  },
};
</script>
